import React from 'react';
import { motion } from 'framer-motion';

const ErsterKundeGarantiertPage = () => {
  return (
    <div className="first-client-page">
      <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem' }}>
        
        {/* Hero Section */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{
            textAlign: 'center',
            marginBottom: '4rem',
            background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%)',
            borderRadius: '20px',
            padding: '3rem',
            border: '1px solid rgba(255, 193, 7, 0.2)'
          }}
        >
          <motion.h1
            style={{
              fontSize: '3rem',
              fontWeight: '800',
              marginBottom: '1.5rem',
              background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              lineHeight: '1.2'
            }}
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Du bist nur einen zahlenden Kunden davon entfernt, alles zu ändern. Aber die "Technik" killt deinen Traum.
          </motion.h1>
        </motion.section>
        
        {/* Video Embed */}
        <div style={{ position: 'relative', width: '100%', paddingBottom: '56.25%', margin: '2rem 0' }}>
          <iframe 
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '8px' }}
            src="https://www.youtube.com/embed/ITemn_tRqOM?autoplay=1&mute=1&loop=1&playlist=ITemn_tRqOM&controls=1&modestbranding=1"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen>
          </iframe>
        </div>

        {/* Part 1: The Hook */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          style={{ marginBottom: '4rem' }}
        >
          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '15px',
            padding: '2.5rem',
            borderLeft: '4px solid #ff6b6b'
          }}>
            <p style={{
              fontSize: '1.3rem',
              lineHeight: '1.8',
              color: '#e0e0e0',
              marginBottom: '0'
            }}>
              Lass mich raten. Du hast einen Tagesjob, aber du weißt, dass du für mehr bestimmt bist. Du hast eine Fähigkeit, für die Menschen bezahlen würden. Dein Traum ist, ein Nebeneinkommen aufzubauen, das schließlich deine Freiheit erkauft.
            </p>
          </div>

          <div style={{ marginTop: '2rem' }}>
            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.7',
              color: '#b0b0b0',
              marginBottom: '1.5rem'
            }}>
              Also hast du angefangen. Du hast den Gurus zugehört. Und du bist direkt in die Falle getappt.
            </p>

            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.7',
              color: '#b0b0b0',
              marginBottom: '1.5rem'
            }}>
              Du hast ein Dutzend Tools gekauft, die Einfachheit versprachen, aber ein Spaghetti-Chaos aus Komplexität lieferten. Du hast versucht, eine Landingpage zu bauen, eine E-Mail-Liste zu verbinden, ein "Freebie" zu erstellen... und jetzt ertrinkst du in einem Meer aus Tabs, Tutorials und technischem Kauderwelsch.
            </p>

            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.7',
              color: '#b0b0b0',
              marginBottom: '1.5rem'
            }}>
              Du hast Wochen, vielleicht Monate mit dem "Setup" verbracht. Aber du bist keinen Schritt näher daran, bezahlt zu werden. Tatsächlich bist du weiter entfernt, weil du jetzt frustriert, überfordert bist und anfängst zu glauben, dass du vielleicht einfach nicht "technisch" genug bist, um das zum Laufen zu bringen.
            </p>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 107, 0.1) 0%, rgba(255, 142, 83, 0.1) 100%)',
              borderRadius: '10px',
              padding: '1.5rem',
              marginTop: '2rem',
              border: '1px solid rgba(255, 107, 107, 0.2)'
            }}>
              <p style={{
                fontSize: '1.3rem',
                fontWeight: '600',
                color: '#ff6b6b',
                margin: '0',
                textAlign: 'center'
              }}>
                Das ist kein Technik-Problem. Es ist ein Fokus-Problem. Du arbeitest an Aufgaben, die dir kein Geld bringen.
              </p>
            </div>
          </div>
        </motion.section>

        {/* Part 2: The Problem & Agitation */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          style={{ marginBottom: '4rem' }}
        >
          <h2 style={{
            fontSize: '2.2rem',
            fontWeight: '700',
            color: '#ff6b6b',
            marginBottom: '2rem',
            textAlign: 'center'
          }}>
            Das wahre Problem
          </h2>

          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '15px',
            padding: '2.5rem',
            marginBottom: '2rem'
          }}>
            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.7',
              color: '#b0b0b0',
              marginBottom: '1.5rem'
            }}>
              Du denkst, dein Problem ist, dass du nicht weißt, welchen Button du klicken musst. Aber das wahre Problem ist, dass du dich darauf konzentrierst, ein "Systemadministrator" zu sein, anstatt ein Geschäftsinhaber.
            </p>

            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.7',
              color: '#b0b0b0',
              marginBottom: '0'
            }}>
              Du versuchst, eine komplexe Rakete zu bauen, wenn alles, was du brauchst, ein zuverlässiges Auto ist, um dich zu deinem ersten Ziel zu bringen: <strong style={{ color: '#ffc107' }}>Dein erster zahlender Kunde.</strong>
            </p>
          </div>

          <div style={{
            background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%)',
            borderRadius: '15px',
            padding: '2.5rem',
            border: '1px solid rgba(255, 193, 7, 0.2)'
          }}>
            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              color: '#ffc107',
              marginBottom: '1.5rem'
            }}>
              Die Kosten des Nichtstuns
            </h3>

            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.7',
              color: '#b0b0b0',
              marginBottom: '1.5rem'
            }}>
              Jede Woche, die du mit dem "Basteln" an deinem Tech-Stack verbringst, ist eine weitere Woche, in der du kein Geld verdienst. Es ist eine weitere Woche, in der dein Traum verblasst.
            </p>

            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.7',
              color: '#b0b0b0',
              marginBottom: '0'
            }}>
              Dein Ziel ist nicht nur, "ein Geschäft zu starten". Es ist, deine Zeit und dein Leben zurückzukaufen. Wenn du auf diesem Weg bleibst, wirst du in sechs Monaten einen perfekt organisierten Ordner mit ungenutzten Tools haben... und null Kunden. Du wirst aufgegeben haben. <strong style={{ color: '#ff6b6b' }}>Die Kosten sind nicht €399. Die Kosten sind deine gesamte Zukunft.</strong>
            </p>
          </div>
        </motion.section>

        {/* Part 3: The Solution */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          style={{ marginBottom: '4rem' }}
        >
          <div style={{
            background: 'linear-gradient(135deg, rgba(100, 255, 218, 0.1) 0%, rgba(0, 255, 136, 0.1) 100%)',
            borderRadius: '20px',
            padding: '3rem',
            border: '1px solid rgba(100, 255, 218, 0.2)',
            textAlign: 'center'
          }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '800',
              color: '#64ffda',
              marginBottom: '2rem'
            }}>
              Ich stelle vor: Der "Erster Kunde, Garantiert" Sprint
            </h2>

            <p style={{
              fontSize: '1.3rem',
              lineHeight: '1.7',
              color: '#e0e0e0',
              marginBottom: '1.5rem'
            }}>
              Das ist kein Kurs. Das ist kein "Coaching". Das ist ein 30-tägiger, mit-dir-gemeinsam Umsetzungs-Sprint mit einem einzigen, obsessiven Fokus: <strong style={{ color: '#64ffda' }}>Dir deinen ersten zahlenden Kunden zu holen.</strong>
            </p>

            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.7',
              color: '#b0b0b0',
              marginBottom: '1.5rem'
            }}>
              Wir werden die ganze Komplexität herausreißen. Wir werden 99% der Dinge ignorieren, die du tun könntest, und uns nur auf die 3-5 kritischen Aktionen konzentrieren, die direkt zu einer Zahlungsbenachrichtigung in deinem Posteingang führen.
            </p>

            <p style={{
              fontSize: '1.2rem',
              fontWeight: '600',
              color: '#64ffda',
              marginBottom: '0'
            }}>
              Wir werden den kürzestmöglichen Weg von dort, wo du jetzt bist, bis zur Bezahlung bauen.
            </p>
          </div>
        </motion.section>

        {/* Part 4: The Offer Stack */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          style={{ marginBottom: '4rem' }}
        >
          <h2 style={{
            fontSize: '2.2rem',
            fontWeight: '700',
            color: '#ffc107',
            marginBottom: '2rem',
            textAlign: 'center'
          }}>
            So genau werden wir dich dorthin bringen:
          </h2>

          <div style={{ display: 'grid', gap: '2rem', marginBottom: '3rem' }}>
            {/* Offer Item 1 */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '15px',
              padding: '2rem',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#64ffda',
                  margin: '0'
                }}>
                  1. Die 'Unwiderstehliches Angebot' Blueprint Session
                </h3>
                <span style={{
                  background: '#ffc107',
                  color: '#000',
                  padding: '0.3rem 0.8rem',
                  borderRadius: '20px',
                  fontSize: '0.9rem',
                  fontWeight: '600'
                }}>
                  Wert: €500
                </span>
              </div>
              <p style={{
                fontSize: '1.1rem',
                lineHeight: '1.6',
                color: '#b0b0b0',
                margin: '0'
              }}>
                Bevor wir irgendeine Technik anfassen, werden wir 90 Minuten 1-zu-1 verbringen, um deine rohe Fähigkeit in ein unwiderstehliches, hochpreisiges Angebot zu schmieden, das Menschen tatsächlich kaufen wollen. Du verlässt diese Session mit einem kristallklaren Angebot, das du für €500-€2.000 verkaufen kannst, wodurch die Investition in diesen Sprint sofort trivial wird.
              </p>
            </div>

            {/* Offer Item 2 */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '15px',
              padding: '2rem',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#64ffda',
                  margin: '0'
                }}>
                  2. Das 'SaaS Slayer' Tech-Stack Setup
                </h3>
                <span style={{
                  background: '#ffc107',
                  color: '#000',
                  padding: '0.3rem 0.8rem',
                  borderRadius: '20px',
                  fontSize: '0.9rem',
                  fontWeight: '600'
                }}>
                  Wert: €750
                </span>
              </div>
              <p style={{
                fontSize: '1.1rem',
                lineHeight: '1.6',
                color: '#b0b0b0',
                margin: '0'
              }}>
                Schluss mit dem Klicken. Ich werde dich persönlich Schritt für Schritt durch die Einrichtung deines gesamten, vereinfachten Tech-Stacks führen. Landingpage, E-Mail-Anbieter, Buchungssystem. Keine Verwirrung, keine Tutorials. In 2 Stunden hast du eine voll funktionsfähige Kundenakquise-Maschine, bereit zu starten.
              </p>
            </div>

            {/* Offer Item 3 */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '15px',
              padding: '2rem',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#64ffda',
                  margin: '0'
                }}>
                  3. Die 'Fill in the Blank' Landingpage Copy
                </h3>
                <span style={{
                  background: '#ffc107',
                  color: '#000',
                  padding: '0.3rem 0.8rem',
                  borderRadius: '20px',
                  fontSize: '0.9rem',
                  fontWeight: '600'
                }}>
                  Wert: €450
                </span>
              </div>
              <p style={{
                fontSize: '1.1rem',
                lineHeight: '1.6',
                color: '#b0b0b0',
                margin: '0'
              }}>
                Du bist kein Copywriter, also versuche nicht, einer zu sein. Ich gebe dir meine bewährten, hochkonvertierenden Landingpage-Vorlagen. Du brauchst nicht von null anzufangen. Du füllst die Lücken aus, und innerhalb einer Stunde hast du eine Verkaufsseite, die besser ist als das, was 99% deiner Konkurrenz in einem Monat zu erstellen kämpft.
              </p>
            </div>

            {/* Offer Item 4 */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '15px',
              padding: '2rem',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#64ffda',
                  margin: '0'
                }}>
                  4. Der 'Erster Kunde' Akquise-Plan
                </h3>
                <span style={{
                  background: '#ffc107',
                  color: '#000',
                  padding: '0.3rem 0.8rem',
                  borderRadius: '20px',
                  fontSize: '0.9rem',
                  fontWeight: '600'
                }}>
                  Wert: €300
                </span>
              </div>
              <p style={{
                fontSize: '1.1rem',
                lineHeight: '1.6',
                color: '#b0b0b0',
                margin: '0'
              }}>
                Ich zeige dir genau, wie und wo du deine ersten potenziellen Kunden findest und gebe dir die exakten Skripte, um sie von "interessiert" zu einem gebuchten Termin in deinem Kalender zu bringen.
              </p>
            </div>
          </div>

          {/* Price Summary */}
          <div style={{
            background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.15) 0%, rgba(255, 152, 0, 0.15) 100%)',
            borderRadius: '15px',
            padding: '2.5rem',
            border: '2px solid rgba(255, 193, 7, 0.3)',
            textAlign: 'center'
          }}>
            <div style={{ marginBottom: '1.5rem' }}>
              <p style={{
                fontSize: '1.3rem',
                color: '#b0b0b0',
                margin: '0 0 0.5rem 0'
              }}>
                Gesamtwert: <span style={{ color: '#ffc107', fontSize: '1.5rem', fontWeight: '700' }}>€2.000</span>
              </p>
              <p style={{
                fontSize: '1.5rem',
                color: '#e0e0e0',
                fontWeight: '700',
                margin: '0'
              }}>
                Du zahlst heute: <span style={{ color: '#ffc107', fontSize: '2rem' }}>€997</span>
              </p>
            </div>

            <p style={{
              fontSize: '1.2rem',
              color: '#b0b0b0',
              fontWeight: '600',
              margin: '0'
            }}>
              Du bekommst ein €2.000 System, entwickelt um dir einen €1.000 Kunden zu bringen, für weniger als €1.000. Die Mathematik spricht für sich.
            </p>
          </div>
        </motion.section>

        {/* Part 5: The Guarantee */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          style={{ marginBottom: '4rem' }}
        >
          <div style={{
            background: 'linear-gradient(135deg, rgba(0, 255, 136, 0.1) 0%, rgba(100, 255, 218, 0.1) 100%)',
            borderRadius: '20px',
            padding: '3rem',
            border: '2px solid rgba(0, 255, 136, 0.3)',
            textAlign: 'center'
          }}>
            <h2 style={{
              fontSize: '2.2rem',
              fontWeight: '800',
              color: '#00ff88',
              marginBottom: '2rem'
            }}>
              Die 'Erster Kunde, Garantiert' Garantie
            </h2>

            <p style={{
              fontSize: '1.3rem',
              lineHeight: '1.7',
              color: '#e0e0e0',
              marginBottom: '1.5rem'
            }}>
              Mein Versprechen steht im Namen des Sprints. Wir werden 30 Tage zusammenarbeiten, um das System umzusetzen. Wenn du die Arbeit machst und du innerhalb dieser 30 Tage nicht deinen ersten zahlenden Kunden landest, werde ich kostenlos mit dir arbeiten, bis du es schaffst. Punkt.
            </p>

            <p style={{
              fontSize: '1.2rem',
              fontWeight: '700',
              color: '#00ff88',
              margin: '0'
            }}>
              Du bekommst entweder das Ergebnis, für das du bezahlt hast, oder du bekommst meine Zeit kostenlos. Das Risiko liegt zu 100% bei mir.
            </p>
          </div>
        </motion.section>

        {/* Part 6: Call To Action */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          style={{ marginBottom: '4rem' }}
        >
          <div style={{
            background: 'linear-gradient(135deg, rgba(255, 107, 107, 0.1) 0%, rgba(255, 142, 83, 0.1) 100%)',
            borderRadius: '20px',
            padding: '3rem',
            border: '1px solid rgba(255, 107, 107, 0.2)',
            textAlign: 'center'
          }}>
            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.7',
              color: '#b0b0b0',
              marginBottom: '2rem'
            }}>
              Das ist ein intensiver, praktischer Sprint. Deshalb kann ich nur <strong style={{ color: '#ff6b6b' }}>5 neue Kunden pro Monat</strong> aufnehmen, um Ergebnisse zu garantieren. Ich habe <strong style={{ color: '#ffc107' }}>3 Plätze übrig</strong> für diesen Monat.
            </p>

            <h3 style={{
              fontSize: '1.8rem',
              fontWeight: '700',
              color: '#ff6b6b',
              marginBottom: '2rem'
            }}>
              Wenn du mit dem Basteln fertig bist und bereit bist, deinen ersten Kunden zu bekommen, hier ist, was als nächstes zu tun ist:
            </h3>

            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '15px',
              padding: '2rem',
              marginBottom: '3rem',
              textAlign: 'left'
            }}>
              <ol style={{
                fontSize: '1.2rem',
                lineHeight: '1.8',
                color: '#b0b0b0',
                paddingLeft: '1.5rem'
              }}>
                <li style={{ marginBottom: '1rem' }}>Klicke auf den Button unten.</li>
                <li style={{ marginBottom: '1rem' }}>Buche einen schnellen, 15-minütigen Call auf meiner TidyCal-Seite.</li>
                <li style={{ marginBottom: '0' }}>In diesem Gespräch werden wir überprüfen, ob das für dich das Richtige ist. Es gibt keinen harten Verkauf. Wenn es passt, bist du dabei. Wenn nicht, gehen wir getrennte Wege.</li>
              </ol>
            </div>

            <p style={{
              fontSize: '1.1rem',
              color: '#b0b0b0',
              marginBottom: '3rem',
              fontStyle: 'italic'
            }}>
              Dieser Call ist da, um sicherzustellen, dass ich dir tatsächlich helfen kann. Ich nehme nur Kunden an, bei denen ich zu 100% zuversichtlich bin, dass ich Ergebnisse erzielen kann.
            </p>

            <motion.a
              href="https://tidycal.com/mathiasdeppe/clarity-call"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                fontSize: '1.4rem',
                fontWeight: '700',
                padding: '1.5rem 3rem',
                background: 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
                color: '#000',
                textDecoration: 'none',
                borderRadius: '50px',
                boxShadow: '0 10px 30px rgba(255, 193, 7, 0.4)',
                border: '2px solid rgba(255, 255, 255, 0.2)',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}
              whileHover={{ 
                scale: 1.05,
                boxShadow: '0 15px 40px rgba(255, 193, 7, 0.6)',
                y: -2
              }}
              whileTap={{ scale: 0.98 }}
            >
              🚀 Buche deinen Klarheits-Call & sichere dir deinen Platz
            </motion.a>
          </div>
        </motion.section>

      </div>
    </div>
  );
};

export default ErsterKundeGarantiertPage;